import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./instances/App.vue";
import SearchBanner from "./instances/SearchBanner.vue";
import SearchHeader from "./instances/SearchHeader.vue";
import Order from './instances/Order.vue'
import Product from './instances/Product.vue'
import SearchNav from './instances/SearchNav.vue'

// import googleMapCol from './components/search-page/GoogleMap.vue'

const catPage = document.getElementById("app");

if (catPage) {
  const app = createApp(App);
  app.use(createPinia()).mount(catPage);
}

const gdSearch = document.getElementById("gdSearch");

if (gdSearch) {
  const banner = createApp(SearchBanner);
  banner.mount(gdSearch);
}

const googleMap = document.getElementById('googleMap')

if (googleMap) {
  const product = createApp(Product);
  product.use(createPinia()).mount(googleMap);
}


const orderPage = document.getElementById('orderPage')

if (orderPage) {
  const orderApp = createApp(Order);
  orderApp.mount(orderPage);
}

const searchNav = document.getElementById("searchNav");

if (searchNav) {
  const banner = createApp(SearchNav);
  banner.use(createPinia()).mount(searchNav);
}

const gdSearchNav = document.getElementById('gdSearchNav')

if (gdSearchNav) {
  const nav = createApp(SearchHeader);
  nav.use(createPinia()).mount(gdSearchNav);
}
